module.exports = __webpack_public_path__ + "static/banner-plato-fuerte-fce72a4c318f4b8f7554c5b77ad46b2b.jpg";